import { mapActions } from "vuex";
import { commonMixin } from '@/mixins/common'
export default {
    mixins: [commonMixin],
    methods: {
        ...mapActions([
            "updateCustID",
            "updateSerNo",
        ]),
        routeToCustDetail(csid, custName = "") {

            let boxID = csid;

            if (!csid.includes("~")) {
                this.updateCustID(csid);
                this.updateSerNo("");
                localStorage.CustID = csid;
                localStorage.SerNo = "";
            } else {
                this.updateCustID("");
                this.updateSerNo(csid);
                localStorage.CustID = "";
                localStorage.SerNo = csid;
            }

            localStorage.checkMvBack = true;
            if (this.UserInfo.userType === 'box') {
                this.boxCustInfo(boxID, custName);
            } else {
                this.toDetail()
            }
        },
        routeToCustDetail2(custId = "", serNo = "", custName = "") {

            let boxID = '';

            if (custId !== "") {
                this.updateCustID(custId);
                this.updateSerNo("");
                localStorage.CustID = custId;
                localStorage.SerNo = "";
                boxID = custId
            } else {
                this.updateSerNo(serNo);
                this.updateCustID("");
                localStorage.CustID = "";
                localStorage.SerNo = serNo;
                boxID = serNo
            }
            if (this.UserInfo.userType === 'box') {
                this.boxCustInfo(boxID, custName);
            } else {
                this.toDetail()
            }
        },
        toDetail() {
            this.$router.push({
                name: "customer-detail-1",
                params: { id: "CustID" }
            });
        },


    }
};